import React from 'react'
import A from '../../A'
import {
  StickyContainer,
  Sticky
} from 'react-sticky'
import { getValid } from '../../../utils'
import styles from './FilteredList.module.scss'

const compare = ( a, b ) => {
  if (a.node.entry.Name[0] < b.node.entry.Name[0]) {
    return -1;
  }
  if (a.node.entry.Name[0] > b.node.entry.Name[0]) {
    return 1;
  }
  // a deve essere uguale a b
  return 0;
}

class FilteredList extends React.Component {
  constructor(props) {
    super(props)

    this.refContainer = React.createRef()
  }
  renderAll() {
    const {
      tags,
      openPopup,
    } = this.props
    let topOf = 345
    if ( typeof window !== "undefined" ) {
      if ( false && window.innerWidth > 100 ) {
        topOf = (window.innerHeight / 2 ) - 250
      }
    }
    const sorteredTags = tags.sort(compare)
    const arrayIndex = []
    sorteredTags.forEach((v, i) => {
      if (arrayIndex.indexOf(v.node.entry.Name[0]) < 0) {
        arrayIndex.push(v.node.entry.Name[0])
      }
    })
    return arrayIndex.map((v, i) => {
      let out = []
      sorteredTags.forEach((x) => {
        if (x.node.entry.Name[0] === v) {
          out.push(x)
        }
      })
      return (
        <div>
          <Sticky
            relative
            disableCompensation
            topOffset={this.refContainer.current ? this.refContainer.current.getBoundingClientRect().top + 60: 345}
          >{
            ({style, ...rest}) => {
              let additionalStyle = {}
              if (!rest.isSticky) {
                additionalStyle = {}
              }

              return (<div>
                <header className={styles.order} style={{
                  ...style,
                  top: (
                    Math.abs(rest.distanceFromTop) > (rest.calculatedHeight + (
                      this.refContainer.current ? this.refContainer.current.getBoundingClientRect().top - 85 : 270
                    ))
                  ) ? (
                      this.refContainer.current ? this.refContainer.current.getBoundingClientRect().top + 45 : 345
                  ) : style.top,
                  ...additionalStyle
                }}>{v}</header>
                {
                  rest.isSticky ? 
                    <header className={styles.order} style={{visibility: 'hidden'}}>{v}</header>
                    : <noscript />
                }
                <div style={{ paddingLeft: 30, paddingBottom: 10}}>
                  {
                    out.map((e) => {
                      return (<div
                        className={styles.voci}>
                        <A
                          onClick={() => openPopup(
                            getValid(e.node.properties.Name_it, e.node.entry.Name),
                            getValid(e.node.properties.Description_it, e.node.entry.Description),
                            this.createTagsForPopup(e.node.entry.Tags),
                            'i'
                          )}
                        >
                          {e.node.entry.Name}
                        </A></div>)
                    })
                  }
                </div>
              </div>
              )
          }
          }
          </Sticky>
        </div>
      )
    })
  }

  renderListOnSearch() {
    const {
      tags,
      openPopup,
      text,
    } = this.props
    let index = 0;
    const buff = tags.map((e, i) => {
      if (e.node.entry.Name.toUpperCase().substring(0, text.length) === text.toUpperCase()) {
        index += 1;
        return (<div
          className={styles.voci + (index === 1 ? ` ` + styles.first : ``)}
          >
            <A
              onClick={() => openPopup(
                getValid(e.node.properties.Name_it, e.node.entry.Name),
                getValid(e.node.properties.Description_it, e.node.entry.Description),
                this.createTagsForPopup(e.node.entry.Tags),
                'i'
              )}
            >
              {e.node.entry.Name}
            </A>
          </div>)
      } else {
        return (<div />)
      }
    })
    return (
      <div style={{paddingTop: 0, paddingLeft: 30}}>{buff}</div>
    )
  }

  renderApply = () => (<p
      style={{
        marginTop: 25,
        marginLeft: 30,
      }}
    >
      {``}
      Completa la parola desiderata, poi clicca su <strong>“Applica”&nbsp;</strong>
      per avere tutte le informazioni sulla specifica soluzione.
    </p>)

  renderFunc() {
    const { text, size } = this.props

    if (text === '') {
      return this.renderAll()
    }
    if (size > 0) {
      return this.renderListOnSearch()
    }
    return this.renderApply()
  }

  createTagsForPopup(origin) {
    const alltags = this.props.servizi
    return alltags.map((e, i) => {
      const node = e.node

      for (let i = 0 ; i < origin.length ; i++ ) {
        if (origin[i]._id === node.id ) {
          return {
            ...node,
            active: true
          }
        }
      }
      return {
        ...node,
        active: false
      }
    })
  }

  render() {
    return (
      <div
        className={styles.container}
        ref={this.refContainer}
      >
        <div className={styles.hideVoci}></div>
        <StickyContainer className={styles.innerContainer}>
          { this.renderFunc() }
        </StickyContainer>
      </div>
    )
  }
}
export default FilteredList